import { themeOverridesSchema } from '@messenger/types'
import type {
  GetThemeOverrideNormalized,
  GetThemeNormalized,
  GetThemeCategoriesNormalized,
  GetPinnedThemeNormalized,
} from '@messenger/types'
import axios from '@/api/axios.config'
import { z } from 'zod'

export const getThemeCategories = async (opts?: {
  orderId?: string
  productId?: string
}) => {
  const query = new URLSearchParams()
  if (opts?.orderId) query.set('order_id', opts.orderId)
  if (opts?.productId) query.set('product_id', opts.productId)
  const suffix = query.toString() ? `?${query.toString()}` : ''
  return await axios.get<GetThemeCategoriesNormalized[]>(
    `themeCategories${suffix}`,
  )
}

export const getPinnedThemes = async () => {
  return await axios.get<GetPinnedThemeNormalized[]>(`pinnedThemes`)
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const createPinnedThemes = async (payload: { themeId: string }) => {
  return await axios.post(`createPinnedTheme`, payload)
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const deletePinnedThemes = async (pinnedThemeId: string) => {
  return await axios.delete(`pinnedThemes/${pinnedThemeId}`)
}

export const getThemeOverride = async (
  themeId: z.infer<typeof themeOverridesSchema>['themeId'],
  productId: z.infer<typeof themeOverridesSchema>['productId'],
  applicationType: z.infer<typeof themeOverridesSchema>['applicationType'],
) => {
  return await axios.get<GetThemeOverrideNormalized[]>(
    `themeOverrides?product_id=${productId}&theme_id=${themeId}&application_type=${applicationType}`,
  )
}

export const getThemeById = async (themeId: string) => {
  return await axios.get<GetThemeNormalized>(`themes/${themeId}`)
}

/** @deprecated Backend route not implemented; remove usages or behind a feature flag. */
export const getWatermark = async (watermarkId: string) => {
  return await axios.get(`watermarks/${watermarkId}`)
}
